import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../auth.service';
import { ForgotPasswordService } from './forgot-password.service';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss']
})

export class ForgotPasswordComponent {
    forgotPasswordForm: FormGroup;
    userNameFormControl = new FormControl('', [Validators.required, Validators.email]);
    isSubmitted = false;

    constructor(
        private formBuilder: FormBuilder,
        private authService: AuthService,
        private forgotPasswordService: ForgotPasswordService,
        private translateService: TranslateService,
        private toastr: ToastrService
    ) {
        this.forgotPasswordForm = this.formBuilder.group({
            userNameFormControl: this.userNameFormControl
        });
    }

    sendPassword() {
        const email = this.userNameFormControl.value;

        this.forgotPasswordService.sendPassword(email).subscribe(result => {
            if (result.model) {
                this.isSubmitted = true;
            } else {
                this.isSubmitted = false;
                this.toastr.error(this.translateService.instant(result.error.message));
            }
        });
    }

    onSignOut() {
        this.authService.signOut();
    }
}
